module.exports = __webpack_public_path__ + "static/img/积分.06e799d.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/积分.png
// module id = 41
// module chunks = 18